// extracted by mini-css-extract-plugin
export default {"container":"styles_container__+Xqtf","logo":"styles_logo__aLbIn"};